<template>
  <div class="residential-account-summary">
    <div class="residential-account-summary__left">
      <div class="residential-account-summary__left-title">{{ $t('residentialAccount', 1) }}</div>
      <div class="residential-account-summary__left-project">{{ $path('project.name', value) }}</div>
      <h1 class="residential-account-summary__left-name">{{ value.name }}</h1>
      <ReadMore class="residential-account-summary__left-description" :value="description" placement="center" />
    </div>

    <div class="residential-account-summary__right">
      <div v-if="value.address && value.address.formatted" class="residential-account-summary__address">
        <FontAwesomeIcon :icon="['fal', 'map-marker-alt']" size="1x" />
        <div>{{ value.address.formatted }}</div>
      </div>
      <slot name="actions" />
    </div>
  </div>
</template>
<script>
import ReadMore from '@kvass/read-more';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    description() {
      return this.value.description
    },
  },
  components: {
    ReadMore,
  },
}
</script>

<style lang="scss">
.residential-account-summary {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;

  @include respond-below('phone') {
    & > * {
      width: 100%;
    }
  }

  h1 {
    margin: 0;
  }

  &__address {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    font-weight: bold;
    font-size: 1.1em;
  }

  &__left {
    max-width: 500px;

    &-title {
      font-weight: bold;
      text-transform: uppercase;
      color: css-lighten('primary', 10%);
      font-size: 0.9em;
      margin-bottom: 0.5rem;
    }

    &-project {
      font-weight: bold;
      font-size: 1.2em;
    }
  }

  &__right {
    display: flex;
    gap: 1rem;

    flex-direction: column;
    justify-content: flex-start;
  }

  .kvass-read-more--active:before {
    background-color: white;
  }
}
</style>
